import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ClientInputContentGroup, ClientInputContent, IClientInputContentRequestHttp } from 'client/models';
import { InputControllerTypes } from 'common/enums';
import { inputControllerTypesToValue, optionWithCommentRequired } from 'common/helper/common';
import { IDataStringExtraValue } from 'common/model';

export const getWithExtraValue = (item: IDataStringExtraValue): [string | undefined, IDataStringExtraValue | undefined] => {
  const val: [string | undefined, IDataStringExtraValue | undefined] = [undefined, undefined];
  if (item.dataStringExtraValue) {
    val[1] = item;
  } else {
    val[0] = item.dataStringValue ? item.dataStringValue : item.toString();
  }
  return val;
}


export const generateFormGroupForInputContentGroup = (
  fb: FormBuilder, group: ClientInputContentGroup
): FormGroup => {
  const formGroup = fb.group({});
  group.inputContents.forEach((inputContent) => {
    formGroup.addControl(inputContent.inputContentGuid, generateFormGroupForInputContent(formGroup, inputContent));
  });
  return formGroup;
};

export const generateFormGroupForInputContent = (
  forGroup: FormGroup, inputContent: ClientInputContent
): FormGroup => {
  const validators = [];
  // Hidden fields are never required: the submitter can't see or fill them, so a required
  // validator on one blocks the step with an error pointing at a control that isn't on screen
  // and can't be fixed. Server-populated fields (e.g. the contact reference, which the API
  // always assigns on submit) are exactly this shape — mandatory AND hidden.
  if (inputContent.isMandatory && !inputContent.isHidden) {
    validators.push(Validators.required);
    if (inputContent.inputControllerType === InputControllerTypes.DropdownWithExtraText) {
      validators.push(optionWithCommentRequired);
    }
  }
  if (inputContent.regEx) {
    validators.push(Validators.pattern(inputContent.regEx));
  }

  const inputControllerTypeName = inputContent.inputControllerType;
  if (inputControllerTypeName === InputControllerTypes.Checkboxes) {
    forGroup.addControl(inputContent.inputContentGuid, new FormControl([], { validators }));
  } else {
    forGroup.addControl(inputContent.inputContentGuid, new FormControl('', { validators }));
  }

  return forGroup;
};


export const prepareSaveInputContentsRequest = (formObj: any, inputContents: ClientInputContent[]): IClientInputContentRequestHttp[] => {
  const inputContentResponse: IClientInputContentRequestHttp[] = [];
  Object.keys(formObj).forEach((key: any) => {
    if (!key.startsWith(ClientInputContentGroup.KeyInitials)) { // Ignore items except input content group like recaptcha.
      return;
    }
    const group = formObj[key];
    Object.keys(group).forEach((evideInputContentGuid) => {
      let value = group[evideInputContentGuid];

      const inputContent: ClientInputContent | undefined = inputContents.find(item => item.inputContentGuid === evideInputContentGuid);
      const inputControllerType = inputContent?.inputControllerType;
      const stringValues = inputControllerTypesToValue(inputControllerType, value);
      inputContentResponse.push({
        evideInputContentGuid: evideInputContentGuid,
        ...stringValues
      });
    });
  });

  return inputContentResponse;
};

